import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Webcam from "react-webcam";
import {
  nextDataEntryForm,
  nextExam,
  resetTempDataEntryData,
  setDataEntryData,
  setIsTypingStarted,
  setRemainingTime,
  setStartTime,
  setTempDataEntryData,
  updateDataEntryData,
} from "../actions/assessment";
import { SaveUserStateToServerHelper } from "../components/Helper";
import DataEntryForm from "../components/PracticeTests/DataEntryForm";
import config from "../config/config-secret.json";

export class DataEntryTest extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  state = {
    practice_answer:
      this.props.assessment.exams[this.props.assessment.exam_index]
        .practice_answer,
    submit_count: 0,
  };

  is_typing_started = () => {
    if (!this.props.is_typing_started) {
      this.props.setIsTypingStarted(true);
      this.props.setStartTime();
      if (this.props.assessment.has_security_features) {
        this.addCaptureImage(
          this.webcamRef.current.getScreenshot(),
          new Date()
        );
      }
    }
  };

  handleChange = (event) => {
    this.setState({ practice_answer: event.target.value });
    let exams = this.props.assessment.exams;
    exams[this.props.assessment.exam_index].practice_answer =
      event.target.value;
  };

  componentDidUpdate(prevProps, prevState) {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    let formData = JSON.parse(
      this.props.questions[this.props.data_entry.data_index]
        .reference_typing_text
    );
    const dataEntryFields = formData.map((field, index) => {
      return (
        <tr key={index}>
          <td>{field.fieldname}</td>
          <td>{field.value}</td>
        </tr>
      );
    });

    return (
      <div className="main container-fluid h-100">
        <div className="row justify-content-center align-items-center">
          <div className="col-12">
            <div className="container">
              <TransitionGroup className="card-container">
                <CSSTransition
                  key={this.props.question.id}
                  timeout={500}
                  classNames="fade"
                >
                  <div className="test">
                    <div className="question typing">
                      {this.props.assessment.has_security_features && (
                        <Webcam
                          className="col-12 mb-4"
                          style={{
                            position: "absolute",
                            right: "100%",
                            display: "block",
                          }}
                          screenshotFormat="image/jpeg"
                          muted={false}
                          ref={this.webcamRef}
                          onUserMediaError={this.onUserMediaError}
                          onUserMedia={this.onUserMedia}
                        />
                      )}

                      <span className="question-number">
                        Form {this.props.data_entry.form_index + 1}
                      </span>

                      {this.props.data_entry.form_index === 0 && (
                        <h4>
                          <span>
                            The timer will begin when you type your first
                            character in the first field. Remember, when you
                            complete typing the last string of a form, press the
                            Enter key to move to the next form.{" "}
                          </span>
                        </h4>
                      )}

                      <div className="row">
                        <div className="col-6">
                          <h6 className="mb-3">Text to be typed :</h6>

                          <div className="card d-entry h-100">
                            <div
                              className="card-body"
                              style={{ userSelect: "none" }}
                            >
                              <table className="table table-bordered">
                                <tbody>{dataEntryFields}</tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <h6 className="mb-3">Type text here :</h6>

                          <div className="card d-entry h-100">
                            <div className="card-body">
                              <DataEntryForm
                                dataEntry={this.props.data_entry}
                                nextDataEntryForm={this.props.nextDataEntryForm}
                                is_typing_started={this.is_typing_started}
                                view={this.props.view}
                                questions={this.props.questions}
                                updateDataEntryData={
                                  this.props.updateDataEntryData
                                }
                                temp_data_entry_data={
                                  this.props.temp_data_entry_data
                                }
                                setTempDataEntryData={
                                  this.props.setTempDataEntryData
                                }
                                resetTempDataEntryData={
                                  this.props.resetTempDataEntryData
                                }
                                data_entry_data={this.props.data_entry_data}
                                setDataEntryData={this.props.setDataEntryData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  view: state.assessment.view,
  questions: state.assessment.exams[state.assessment.exam_index].questions,
  question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
  is_typing_started: state.assessment.is_typing_started,
  data_entry: state.assessment.data_entry,
  data_entry_data: state.assessment.data_entry_data,
  temp_data_entry_data: state.assessment.temp_data_entry_data,
});

const mapDispatchToProps = (dispatch) => ({
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  setIsTypingStarted: (value) => dispatch(setIsTypingStarted(value)),
  setStartTime: () => dispatch(setStartTime(Date.now())),
  nextDataEntryForm: (counter) => dispatch(nextDataEntryForm(counter)),
  updateDataEntryData: (counter, data) =>
    dispatch(updateDataEntryData(counter, data)),
  setTempDataEntryData: (tempData) => dispatch(setTempDataEntryData(tempData)),
  resetTempDataEntryData: () => dispatch(resetTempDataEntryData()),
  setDataEntryData: (dataEntryData, dataEntryCount) =>
    dispatch(setDataEntryData(dataEntryData, dataEntryCount)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DataEntryTest);
